
//Default active element of header is Dashboard(1)
export const HEADER_ACTIVE_ITEM = 1;

//Toast notification styles
export const ToastStyles = {
  position: "top-center",
  autoClose: 4000,
  hideProgressBar: true,
  newestOnTop: true,
  closeOnClick: true,
  pauseOnVisibilityChange: true,
  draggable: true,
  pauseOnHover: true,
  closeButton:false
};

export const MAX_MOBILE_NUMBER_LENGTH=15;
export const MIN_MOBILE_NUMBER_LENGTH=6;

export const MANDATORY_LOGO = "*";

export const PAYMENT_STATUS = [
  "pending",
  "initiated",
  "success",
  "error",
  "failed",
  "expired",
  "opened"
];
export const TYPE = {
  file: "file",
  url: "url"
};

export const MONTH_NAMES = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December"
];

export const MONTH_NAMES_SHORT = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec"
];
export const DAY_NAMES = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday"
];

export const MONTH_NAMES_AR = [
  "كانون الثاني",
  "شباط",
  "آذار",
  "نيسان",
  "مايو",
  "حزيران",
  "تموز",
  "آب",
  "أيلول",
  "تشرين الأول",
  "تشرين الثاني",
  "كانون الأول"
];
export const MONTH_NAMES_SHORT_AR = [
  "كانون الثاني",
  "شباط",
  "آذار",
  "نيسان",
  "مايو",
  "حزيران",
  "تموز",
  "آب",
  "أيلول",
  "تشرين الأول",
  "تشرين الثاني",
  "كانون الأول"
];
export const DAY_NAMES_AR = [
  "الأحد",
  "الاثنين",
  "الثلاثاء",
  "الأربعاء",
  "الخميس",
  "الجمعة",
  "السبت"
];
export const DAY_NAMES_MIN_AR = ["ح", "ن", "ث", "ر", "خ", "ج", "س"];

export const DAY_NAMES_MIN = ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"];

export const DATEPICKER_DATE_FORMAT="dd-mm-yy"
export const ARABIC = "ar";
export const MAX_FILE_SIZE_FOR_BULK_UPLOAD = 100000;
export const SUPER_ADMIN="Super Admin";
export const TENANT_ID="tenantID";
export const DEFAULT_ACTION="1";
export const DEFAULT_CURRENCY="414";
export const DEFAULT_LANG="ENG";
//export const CurrentTenant="CurrentTenant"





// WEBPACK FOOTER //
// ./src/utils/constants.js